import * as React from "react";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import ModelProviderRequiredAlert from "aiagent/components/ModelProviderRequiredAlert";
import columnRenderers from "./AgentWorkflows/ColumnRenderers";
import { DEFAULT_LAYOUT } from "./AgentWorkflows/Constants";
import useWorkflowDefinitions from "./AgentWorkflows/hooks/useWorkflowDefinitions";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
const AgentWorkflowsPage = () => {
  const { fetchWorkflowDefinitions, keyFn } = useWorkflowDefinitions();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "AI Agent Workflows" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "AI Agent Workflows" }, /* @__PURE__ */ React.createElement("span", null, "AI agent workflows run recurring checks across Graylog security data. They review high-risk assets and create investigations for confirmed threats, suggest tuning for noisy event definitions, and flag older open investigations so analysts know what needs attention. Configure the provider and model, control scheduled runs, and review the latest result.")), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ModelProviderRequiredAlert, null), /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "AI agent workflows",
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchWorkflowDefinitions,
      keyFn,
      columnRenderers,
      entityAttributesAreCamelCase: false,
      noPageSizeSelect: true
    }
  ))));
};
export default AgentWorkflowsPage;
